<script setup lang="ts">


var props = defineProps({
  isLoading: { type: Boolean, required: true, default: false },
  mensagem: { type: String, required: true, defaul: "Processando..." },
  spinerTipo: { type: String, required: false, default: "spinner-border spinner-border-sm" },
  corFont: { type: String, required: false, default: "text-white" },
  corSpiner: { type: String, required: false, default: "text-white" },
});
</script>

<template>
  <div v-if="isLoading">
    <!-- Tela de loading -->
    <div class="carregando d-flex flex-column justify-content-center align-items-center">
      <div class="loading p-4 bg-dark rounded">
        <div class="mb-2" :class="corSpiner">

        </div>
        <div class=" fw-bold fs-5" :class="corFont">
          <i class="me-2" :class="spinerTipo" />
          <label >
            {{ mensagem }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.carregando {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.658);
  z-index: 999999999;
}

.fa-lg {
  font-size: xx-large !important;
}
</style>
